import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { Footer } from "../../Common/Components/Footer";
import { UpperNav } from "../../Common/Components/UpperNav";
import { ZonePicker } from "../Pages/ZonePicker";
import { AddressPicker } from "./AddressPicker";
import { AppNav } from "./AppNav";
import { MaintenanceWrapper } from "../../Common/Components/MaintenanceWrapper";

export const AppWrapper = () => {
  const zone = useSelector((x) => x.Zone);
  const loggedIn = useSelector((x) => x.LoggedIn);
  const userType = useSelector((x) => x.UserType);
  const dispatch = useDispatch();

  const handleAddressSelect = (e) => {
    if (e) {
      dispatch({
        type: "setZone",
        payload: e.laundry_zone_id || e.laundryZoneId,
      });
      dispatch({
        type: "setAddress",
        payload: {
          ...e,
          address: e.address,
          zone_id: e.zone_id || e.zoneId,
          laundry_zone_id: e.laundry_zone_id || e.laundryZoneId,
          cords: {
            lng: e.longitude,
            lat: e.latitude,
          },
        },
      });
    }
  };
  return (
    <>
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <MaintenanceWrapper>
        <UpperNav />
        <AppNav />
          <div style={{ flex: 1 }}>
            {zone ? (
              <>
                <Outlet />
              </>
            ) : loggedIn ? (
              <div style={{ minHeight: "100vh" }}>
                <AddressPicker
                  show={true}
                  title="Please select your order location!"
                  onSelect={handleAddressSelect}
                  showDelete={false}
                  showEdit={false}
                  titleStyle={{ textAlign: "center" }}
                />
              </div>
            ) : userType === false ? (
              <ZonePicker />
            ) : (
              <Navigate to="/app/login" />
            )}
          </div>
        <Footer />
      </MaintenanceWrapper>
    </div>
    </>
  );
};
